import * as React from 'react';
import { Link } from 'react-router-dom';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedComponentClass, LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { AlternateDatesModel } from 'models';

import { AdditionalInfoListItem } from './additional-info';

const TrackedLink = ClickTracker(Link);

export interface AlternateDatesProps extends LocalizedComponentProps {
  handleClick: () => void;
  model: AlternateDatesModel[];
}

export const AlternateDatesComponent: React.FunctionComponent<AlternateDatesProps> = ({ handleClick, l10n, model }) => (
  <React.Fragment>
    {model.map((alternateDate, index) => {
      const { dateRange, price } = alternateDate;
      const { startDate } = dateRange;

      return (
        <AdditionalInfoListItem key={`ad-${startDate}-${index}`}>
          <div className="uitk-grid">
            <AlternateDateLink alternateDate={alternateDate} index={index} l10n={l10n} handleClick={handleClick} />
            <span>{price}</span>
          </div>
        </AdditionalInfoListItem>
      );
    })}
  </React.Fragment>
);
AlternateDatesComponent.displayName = 'AlternateDatesComponent';

export const AlternateDates: LocalizedComponentClass<AlternateDatesProps> = withLocalization(AlternateDatesComponent);

export interface AlternateDateLinkProps extends LocalizedComponentProps {
  alternateDate: AlternateDatesModel;
  handleClick?: () => void;
  index: number;
}

export const AlternateDateLink: React.FunctionComponent<AlternateDateLinkProps> = ({ alternateDate, index, l10n, handleClick }) => {
  const { dateRange, stayDurationNights, url } = alternateDate;
  const { startDate, endDate } = dateRange;
  const startDateFormatted = l10n.formatDateString(startDate, { skeleton: 'MMMEd' });
  const endDateFormatted = l10n.formatDateString(endDate, { skeleton: 'MMMEd' });

  return (
    <TrackedLink
      to={url}
      onClick={handleClick}
      className="uitk-cell all-cell-fill"
      rfrr={`HOT:SR:AltDates.${index}`}
      linkName="HSR alt dates list"
    >
      <p>
        {startDateFormatted} - {endDateFormatted}
      </p>
      ({stayDurationNights})
    </TrackedLink>
  );
};
AlternateDateLink.displayName = 'AlternateDateLink';
